import script from "./TeleLaudoView.vue?vue&type=script&setup=true&lang=js"
export * from "./TeleLaudoView.vue?vue&type=script&setup=true&lang=js"

import "./TeleLaudoView.vue?vue&type=style&index=0&id=dc9d08d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc9d08d4"]])

export default __exports__